import { ACTION_CODE, EVENT_CODE } from '@constants'
import { ActionRow, ObjectDataRecord } from '@types'

import { useOpenForm, useOpenView, useSetVariableValue } from './actions'

export const useExecuteActions = () => {
  const { setVariableValue } = useSetVariableValue()
  const { openForm } = useOpenForm()
  const { openView } = useOpenView()

  const executeActions = async (data: {
    actions: ActionRow[]
    srcObj?: ObjectDataRecord
    eventCode: EVENT_CODE
    isUseCacheCommandRequest?: boolean
  }) => {
    const { actions = [], eventCode, srcObj, isUseCacheCommandRequest } = data

    const methods = actions
      .filter(item => item.eventCode === eventCode)
      .map((action: ActionRow) => {
        switch (action.actionCode) {
          case ACTION_CODE.SET_VARIABLE_VALUE:
            return setVariableValue({ action, srcObj, isUseCacheCommandRequest })
          case ACTION_CODE.OPEN_FORM_MODEL:
            return openForm(action, srcObj)
          case ACTION_CODE.OPEN_VIEW:
            return openView(action, srcObj)
        }
      })

    return Promise.allSettled(methods || [])
  }

  return {
    executeActions,
  }
}
